import { BasicClient } from '@/utils/httpClient'

export default class Auth {
  client
  constructor() {
    this.client = new BasicClient()
  }
  login(user, password, performanceToken = null) {
    const payload = {};
    
    if (user) {
      payload.user = user;
    }
    if (password) {
      payload.password = password;
    }
    if (performanceToken) {
      payload.performanceToken = performanceToken;
    }
    
    return this.client.exec('/v2/auth-mod/login', 'POST', payload);
  }


  loginForConnect(user, password) {
    const payload = {};
    
    if (user) {
      payload.user = user;
    }
    if (password) {
      payload.password = password;
    }
      
    payload.domainMode = 1;
    
    return this.client.exec('/v2/auth-mod/login', 'POST', payload);
  }


  biometricLogin({ deviceId, deviceToken }) {
    const config = {
      headers: {
        'TR-Device': deviceId,
        'TR-DeviceToken': deviceToken
      },
      method: 'POST',
      url: '/mobile/auth'
    }
    return this.client.makeRequest(config);
  }
  loginCustomFile(fileName) {
    return this.client.getFileJson(`${window.location.origin}/e/custom_json/${fileName}_login.json`)
  }
  employeePreferences() {
    return this.client.exec(
      '/v2/auth-mod/mfa/temp/employeePreferences',
      'DELETE'
    )
  }
  loginSSO(ssoToken) {
    return this.client.exec('/v2/auth-mod/login', 'POST', { sso: ssoToken })
  }
  loginSAML(samlRequest, relayState) {
    return this.client.exec('/v2/saml/login', 'POST', {
      samlRequest: samlRequest,
      relayState: relayState
    })
  }
  logoutSAML(samlRequest, sigAlg, signature) {
    return this.client.execLogoutSAML('v2/saml/logout', 'POST', {
      samlRequest: samlRequest,
      sigAlg: sigAlg,
      signature: signature
    })
  }
}
